/**
 * Service/Network Controller
 *
 * Displays information about network-type orders
 */

// the constructor for this object
function ServiceNetworkController() { }

// the object
ServiceNetworkController.prototype = {
    constructor: ServiceNetworkController,

    // the base order id
    baseOrderId: false,
    
    // the maximum number of chart sets
    maxChartSets: 10,
    
    // references to all charts
    /* [{
        interfaceId: 123,
        interfaceType: 53,
        chartSet: 1,
        bitChart: PortalChart,
        errorsChart: PortalChart,
        discardsChart: PortalChart,
        unicastChart: PortalChart
    }] */
    chartSets: [],
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // register network data charts
        this._registerNetworkCharts();
        
        // set the tab box for stats
        this._registerStatTabs();
        
        PortalHelper.debugMessage('Service Network Initialized');
    },
    
    // run the controller
    run: function()
    {
        
        // get and populate generic order information
        this._getOrder();
        
        // setup network charts
        this._getNetworkOrder();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Service Network Controller Ran');
    },
    
    // setup the base chart sets
    _registerNetworkCharts: function()
    {
        for (var i = 1; i <= this.maxChartSets; i++) {
            
            // build the html for the new chart set 
            var newEntry = $('#chart-sets .clone-source').clone();
            newEntry.removeClass('clone-source');
            newEntry.addClass('hidden');
            newEntry.attr('data-chart-set-id', i);
            
            $('#bits-chart', newEntry).attr('id', 'bits-chart-' + i);
            $('#discards-chart', newEntry).attr('id', 'discards-chart-' + i);
            $('#errors-chart', newEntry).attr('id', 'errors-chart-' + i);
            $('#packets-chart', newEntry).attr('id', 'packets-chart-' + i);
            
            $('#bits', newEntry).attr('id', 'bits-' + i);
            $('#discards', newEntry).attr('id', 'discards-' + i);
            $('#errors', newEntry).attr('id', 'errors-' + i);
            $('#packets', newEntry).attr('id', 'packets-' + i);
            
            $('a[data-target="bits"]', newEntry).attr('data-target', 'bits-' + i);
            $('a[data-target="discards"]', newEntry).attr('data-target', 'discards-' + i);
            $('a[data-target="errors"]', newEntry).attr('data-target', 'errors-' + i);
            $('a[data-target="packets"]', newEntry).attr('data-target', 'packets-' + i);
            
            $('#chart-sets').append(newEntry);
            
            
            // bits chart
            var bitsChart = new PortalChart;
            bitsChart.elementId = 'bits-chart-' + i;
            bitsChart.type = 'area';
            bitsChart.dataFormat = 'bits';
            bitsChart.maxRangeValue = 1000000;
            bitsChart.minRangeValue = -1000000;
            bitsChart.columns = [];
            this['bits-chart-' + i] = bitsChart;
            
            // discards chart
            var discardsChart = new PortalChart;
            discardsChart.elementId = 'discards-chart-' + i;
            discardsChart.type = 'area';
            discardsChart.columns = [];
            this['discards-chart-' + i] = discardsChart;
            
            // errors chart
            var errorsChart = new PortalChart;
            errorsChart.elementId = 'errors-chart-' + i;
            errorsChart.type = 'area';
            errorsChart.columns = [];
            this['errors-chart-' + i] = errorsChart;
            
            // packets (Unicast) chart
            var packetsChart = new PortalChart;
            packetsChart.elementId = 'packets-chart-' + i;
            packetsChart.type = 'area';
            packetsChart.columns = [];
            this['packets-chart-' + i] = packetsChart;
            
            // prep the chart set
            var chartSet = {
                interfaceId: null,
                chartSet: i,
                bitsChart: null,
                discardsChart: null,
                errorsChart: null,
                packetsChart: null,
            };
            
            chartSet.bitsChart = bitsChart;
            chartSet.discardsChart = discardsChart;
            chartSet.errorsChart = errorsChart;
            chartSet.packetsChart = packetsChart;
            this.chartSets.push(chartSet);
        }
        
    },
    
    // setup the stat tabs
    _registerStatTabs: function()
    {
        // setup the tabs
        var boxTabs = new PortalBoxTabs;
        boxTabs.tabClickCallback = PortalMain.ServiceNetworkController._tabClickCallback;
        boxTabs.setupBoxTabs('.box-tabs');  
    },
    
    // redraw the chart to fill the now visible space
    _tabClickCallback: function(tabTarget)
    {
        tabTarget = tabTarget.replace('-', '-chart-');
        PortalMain.ServiceNetworkController[tabTarget].draw();
        
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the product cd
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('.range-selection-dropdown');
        $('.range-selection-dropdown ul li a').on('click', function(){
            var selectionLink = $(this);
            PortalMain.ServiceNetworkController._updateChartRange(
                this.dataset.timelineRangeSeconds,
                selectionLink.closest('[data-chart-set-id]').attr('data-chart-set-id')
            );
            
            PortalMain.ServiceNetworkController._updateSelectedRange(this);
        });
        
        // download the csv file of the network stats when clicked
        $('.download-stats').on('click', function(e) {
            e.preventDefault();
            
            PortalMain.ServiceNetworkController._downloadStats(this);
        });
    },
    
    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        
        PortalMain.ServiceIndexController._getOrder();
    },
    
    // Gets network order specific information from the API and sets up the charts
    _getNetworkOrder: function()
    {
        
        var networkOrderRequest = new PortalRequest;
        networkOrderRequest.makeRequest(
            '/network/get-network-order',
            {
                baseOrderId: this.baseOrderId
            },
            function(data) {
                // set up usage charts based on interface type
                PortalMain.ServiceNetworkController._setupNetworkCharts(data.orders_open_nms);
                for (var i in data.orders_open_nms) {
                    var snmpInterface = data.orders_open_nms[i];
                    PortalMain.ServiceNetworkController._acquireNetworkCharts(
                        snmpInterface.snmpinterface_id,
                        snmpInterface.snmpiftype
                    );
                }
            }
        );

    },
    
    // retrieves historical usage information to fill our charts with
    _getNetworkStats: function(type, snmpInterfaceId, startDate, endDate)
    {
        // defaulting to 1 day range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();
            
            startDate.setDate(
                startDate.getDate() - 1
            );
        }
        
        var networkStatsRequest = new PortalRequest;
        networkStatsRequest.makeRequest(
            '/network/get-network-stats',
            {
                baseOrderId: this.baseOrderId,
                interfaceId: snmpInterfaceId,
                chartType: type,
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data, code) {
                if (code != 'NETWORK_STATS_NOT_FOUND') {
                    PortalMain.ServiceNetworkController._populateNetworkChart(data, snmpInterfaceId, type, startDate, endDate);
                }
            },
            function() {
                var chart = PortalMain.ServiceNetworkController[type+'Chart'];
                if ( chart ){
                    $('#' + chart.elementId).text("An unknown error occurred.");
                    PortalHelper.loadingOverlay('#' + chart.elementId, false);
                }
            }
        );
    },
    
    // get the invoice from the api
    _downloadStats: function(clickedElement)
    {
        // get the dropdown element based on the clicked download button
        var dropdownElement = $(clickedElement).parents('.box');
        dropdownElement = $('.selection-popup', dropdownElement);
        
        // apply the chart type
        var chartType = $('*[data-target-chart]', dropdownElement).attr('data-target-chart');
        
        // apply the date range
        var dateRangeSeconds = $('.selection-text', dropdownElement).attr('data-timeline-range-seconds')
        var endDate = new Date();
        var startDate = new Date(endDate.getTime() - (dateRangeSeconds * 1000));
        startDate = startDate.getTime() / 1000|0;
        endDate = endDate.getTime() / 1000|0;
        
        // get the interface id
        var idContainer = $(clickedElement).parents('div[data-chart-set-id]');
        var chartId = $(idContainer).attr('data-chart-set-id');
        for (var i in this.chartSets) {
            if (this.chartSets[i].chartSet == chartId) {
                var interfaceId = this.chartSets[i].interfaceId;
            }
        }
        
        var downloadStatsRequest = new PortalRequest;
        downloadStatsRequest.isBinary = true;
        downloadStatsRequest.makeRequest(
            '/network/download-network-stats',
            {
                baseOrderId: this.baseOrderId,
                interfaceId: interfaceId,
                chartType: chartType,
                startDate: startDate,
                endDate: endDate
            },
            function(data) {
                // build the file name
                var fileName = 'NetworkStats-';
                fileName += $('.order-number .value').html();
                fileName += '-'+ chartType +'.csv';
                
                // download the file
                PortalHelper.downloadFile(data, fileName);
            }
        );
    },
    
    // takes data from the API, and uses it to populate a chart. auto-detects columns.
    _populateNetworkChart: function(data, interfaceId, type, startDate, endDate)
    {
        var chartData = data.chart_data;
        
        // enforce a strict order for the columns
        var ucType = type.charAt(0).toUpperCase() + type.slice(1);
        chartData = PortalHelper.chartOrderColumns(chartData, [
            'Time',
            ucType + ' Download',
            ucType + ' Upload'
        ]);
        
        // find the applicable chartSet
        for (var i in this.chartSets) {
            if (this.chartSets[i].interfaceId == interfaceId) {
                var chartSet = this.chartSets[i];
            }
        }
        
        // set the applicable chart
        var chart = chartSet[type + 'Chart'];
        
        // un-hiding the chart
        $('#' + chart.elementId).parents('.boxes').removeClass('hidden');
        
        chart.minDate = startDate;
        chart.maxDate = endDate;
        
        // resetting columns first
        chart.columns = [];
        for(var i in chartData[0]) {
            var currentField = chartData[0][i];
            if(currentField == 'Time') {
                chart.columns[i] = ['date', currentField];
            } else {
                chart.columns[i] = ['number', currentField];
            }
        }
        
        // show the tab, full tab container
        var chartSetId = chartSet.chartSet;
        $('div[data-chart-set-id=' + chartSetId + ']').removeClass('hidden');
        $('a[data-target="' + type + '-' + chartSetId + '"]').parent().removeClass('hidden');
        
        if(data.length == 1) {
            $('#' + chart.elementId).text("No data available for this period.");
        } else {
            chart.data = chartData;
            chart.draw();
        }
        
        PortalHelper.loadingOverlay('#' + chart.elementId, false);        
        
    },
    
    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds, chartId)
    {
        
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime() 
            - (dateRangeSeconds * 1000)
        );
        
        // get the interface data
        for (var i in this.chartSets) {
            if (this.chartSets[i].chartSet == chartId) {
                var interfaceId = this.chartSets[i].interfaceId;
                var interfaceType = this.chartSets[i].interfaceType;
            }
        }
        
        PortalHelper.loadingOverlay('div[data-chart-set-id="' + chartId + '"] .network-chart', true);
        
        this._acquireNetworkCharts(interfaceId, interfaceType, startDate, endDate);

    },
    
    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        // get the data from the selected element
        var selectedElementRangeSeconds = $(element).attr('data-timeline-range-seconds');
        var selectedElementText = $(element).text();
        var selectedElementParent = $(element).parents('.box-tabs');
        
        // apply the info to the drodpown label
        $('.selection-text', selectedElementParent).text(selectedElementText);
        $('.selection-text', selectedElementParent).attr('data-timeline-range-seconds', selectedElementRangeSeconds);
    },
    
    // setup the chart sets with the acquired data
    _setupNetworkCharts: function(interfaces)
    {
        for (var i in interfaces) {
            
            var interfaceId = interfaces[i].snmpinterface_id;
            var interfaceType = interfaces[i].snmpiftype;
            var mifAlias = interfaces[i].multi_interface_alias;
            
            // find an existing chart set
            var chartSet = null;
            for (var i in this.chartSets) {
                if (this.chartSets[i].interfaceId == interfaceId) {
                    chartSet = this.chartSets[i];
                }
            }
            
            // apply one if none exists
            if (chartSet == null) {
                for (var i in this.chartSets) {
                    if (this.chartSets[i].interfaceId == null) {
                        this.chartSets[i].interfaceId = interfaceId;
                        this.chartSets[i].interfaceType = interfaceType;
                        var chartSetId = this.chartSets[i].chartSet;
                        break;
                    }
                }
            }
            
            // set the heading
            if (mifAlias) {
                $('div[data-chart-set-id=' + chartSetId + '] span.interface-alias').html(mifAlias + ' - ');
            }
        }
    },
    
    // sets up the appropriate charts for each interface type
    _acquireNetworkCharts: function(interfaceId, interfaceType, startDate = null, endDate = null)
    {
        switch (interfaceType) {
            // Serial Interfaces and Gigabit connections
            case 6:
            case 22:
            case 23:
            case 117:
            case 135:
            case 161:
                this._getNetworkStats('bits', interfaceId, startDate, endDate);
                this._getNetworkStats('discards', interfaceId, startDate, endDate);
                this._getNetworkStats('errors', interfaceId, startDate, endDate);
                this._getNetworkStats('packets', interfaceId, startDate, endDate);
                break;
            // VLANs
            case 53:
            case 131:
                this._getNetworkStats('bits', interfaceId, startDate, endDate);
                break;
            // Multilinks
            case 108:
                this._getNetworkStats('bits', interfaceId, startDate, endDate);
                this._getNetworkStats('discards', interfaceId, startDate, endDate);
                break;
            default:
                break;
        }
    },
    
    
}